import React from 'react'
import { graphql } from 'gatsby'
import Layout from '~/components/Layout'
import Metadata from '~/components/Metadata'
import ContentPage from '~/components/Content/Page'

const constants = {
  backgroundColor: '#F5EFE9',
  navTextColor: '#851B54',
  logoColor: '#851B54',
}

const StaticPageTemplate = ({ data }) => {
  const { page } = data

  return (
    <Layout
      backgroundColor={constants.backgroundColor}
      navTextColor={constants.navTextColor}
      logoColor={constants.logoColor}
    >
      <Metadata title={page.name} />
      <ContentPage page={page} backgroundColor={constants.backgroundColor}/>
    </Layout>
  )
}

export const pageQuery = graphql`
  query StaticPageQuery($slug: String!, $locale: String) {
    page: contentfulPage(slug: { eq: $slug }, node_locale: { eq: $locale }) {
      ...ContentPageFragment
    }
  }
`

export default StaticPageTemplate
